import {
  collection,
  doc,
} from 'firebase/firestore';

import {
  db,
} from '@/services/firebase.js';

import {
  converters,
} from '../converters/index.js';

export const api_key_refs = {
  document: ({
    workspace_id,
    project_id,
    api_key_id,
  }) => {
    const path = [
      'workspaces',
      workspace_id,
      'projects',
      project_id,
      'project_api_keys',
      api_key_id,
    ].join('/');
    return doc(db, path).withConverter(converters.api_keys);
  },
  collection: ({
    workspace_id,
    project_id,
  }) => {
    const path = [
      'workspaces',
      workspace_id,
      'projects',
      project_id,
      'project_api_keys',
    ].join('/');
    return collection(db, path).withConverter(converters.api_keys);
  },
};


